import { Text, View } from "@react-pdf/renderer";
import amlReportStyles from "../Styles/amlReportStyles";
import dayjs from "dayjs";

const Footer = () => {
  const currentYear = dayjs().year();
  return (
    <View style={amlReportStyles.footer} fixed>
      <Text style={amlReportStyles.amlTextFooter}>
      © {currentYear} Rosemount Financial Solutions (IFA) Ltd
      </Text>
    </View>
  );
};


export default Footer;
